import { isGlobalTeamUser } from '@/i18n/localeStorage.js'

const GLOBAL_TEAM_BLOCKED_ROUTE_NAMES = new Set([
  'products.list',
  'products.new',
  'products.item',
])

export function isGlobalTeamHomeRoute(name) {
  return name === 'home'
}

/** Стартовая страница LTMS для пользователей с флагом «Глобальная команда». */
export function canAccessGlobalTeamHome(userStore) {
  return isGlobalTeamUser(userStore.user)
}

export function canMeetRouteRbac(routeName, rbac, userStore) {
  // Стартовая доступна всем авторизованным (после логина и по логотипу)
  if (isGlobalTeamHomeRoute(routeName)) {
    return true
  }
  return !rbac || userStore.can(rbac)
}

export function isProductsRouteBlockedForUser(user) {
  return isGlobalTeamUser(user)
}

export function isProductsRouteName(name) {
  return GLOBAL_TEAM_BLOCKED_ROUTE_NAMES.has(name)
}

export function canAccessRouteName(name, userStore) {
  if (isProductsRouteBlockedForUser(userStore.user) && isProductsRouteName(name)) {
    return false
  }
  return true
}

export function canViewSidebarRoute(route, userStore) {
  if (route.meta?.sidebar !== true) {
    return false
  }
  // Parent folders without own page: show if any child is visible
  if (Array.isArray(route.children) && route.children.length && !route.component) {
    return route.children.some(child => canViewSidebarRoute(child, userStore))
  }
  if (route.meta?.rbac && !userStore.can(route.meta.rbac)) {
    return false
  }
  if (!canAccessRouteName(route.name, userStore)) {
    return false
  }
  return true
}
